import { inject } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ClientLogger } from 'bernie-client';
import { LocalizedText } from 'bernie-l10n';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkPill } from 'uitk-react-pill';
import { UitkTextInput } from 'uitk-react-input';

import { Form } from 'components/common/form';

const loggerWithId = ClientLogger.getLoggerWithIdentifier('pwa.component.feedback');

const ButtonTracked = ClickTracker(UitkPrimaryButton);

export interface FeedbackFormProps {
  currentHotel?: CurrentHotelStore;
  closeTakeover: () => void;
  submitForm: () => void;
}

export interface FeedbackFormState {
  pills: any;
  textInputValue: string;
}

@inject('currentHotel')
export class FeedbackForm extends React.Component<FeedbackFormProps, FeedbackFormState> {
  constructor(props) {
    super(props);
    this.state = {
      pills: [
        {
          pillId: 'missingInfo',
          label: <LocalizedText message="hotels.infosite.feedback.pills.missingInfo" />,
          selected: false
        },
        {
          pillId: 'cantFinish',
          label: <LocalizedText message="hotels.infosite.feedback.pills.cantFinish" />,
          selected: false
        },
        {
          pillId: 'doesntWork',
          label: <LocalizedText message="hotels.infosite.feedback.pills.doesntWork" />,
          selected: false
        },
        {
          pillId: 'other',
          label: <LocalizedText message="hotels.infosite.feedback.pills.other" />,
          selected: false
        }
      ],
      textInputValue: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.updateTextInput = this.updateTextInput.bind(this);
    this.selectPill = this.selectPill.bind(this);
  }

  private onSubmit(event) {
    event.preventDefault();
    loggerWithId.logEvent(new SystemEvent(SystemEventLevel.INFO, 'FEEDBACK_FORM_ON_SUBMIT'), this.buildClientLog());
    this.props.submitForm();
  }

  private buildClientLog() {
    return Object.assign(
      {},
      {
        textInputValue: `"${this.state.textInputValue}"`,
        pillsSelected: `"${this.state.pills.filter(pill => pill.selected).map(pill => pill.pillId)}"`,
        hotelId: `"${this.props.currentHotel.hotelId}"`
      }
    );
  }

  private updateTextInput(event) {
    this.setState({
      textInputValue: event.target.value
    });
  }

  private selectPill(event, selectedIndex) {
    this.setState({
      pills: this.state.pills.map((pill, index) => {
        const selected = index === selectedIndex ? !pill.selected : pill.selected;

        return {
          ...pill,
          selected
        };
      })
    });
  }

  public render() {
    const { pills, textInputValue } = this.state;

    return (
      <div className="all-x-padding-three all-y-padding-six">
        <div className="uitk-cell">
          <h3 className="uitk-type-heading-500">
            <LocalizedText message="hotels.infosite.feedback.form.title" />
          </h3>
        </div>
        <Form onSubmit={this.onSubmit} noValidate={true}>
          <div className="uitk-grid uitk-cell all-y-padding-three">
            {pills &&
              pills.map((pill, i) => {
                const selectPill = event => this.selectPill(event, i);

                return (
                  <UitkPill
                    key={i}
                    checked={pill.selected}
                    id={`feedbackPill-${i}`}
                    onChange={selectPill}
                    className="uitk-cell all-cell-shrink"
                  >
                    {pill.label}
                  </UitkPill>
                );
              })}
          </div>
          <div className="uitk-cell all-b-padding-three">
            <UitkTextInput
              value={textInputValue}
              onChange={this.updateTextInput}
              label={<LocalizedText message="hotels.infosite.feedback.form.inputPlaceholder" />}
              id="feedbackInput"
              name="feedbackInput"
            />
          </div>
          <div className="uitk-cell">
            <ButtonTracked
              isFullWidth={true}
              type="submit"
              rfrr=":SubmitFeedback"
              disabled={!textInputValue && pills.filter(item => item.selected).length <= 0}
              linkName="SUBMIT FEEDBACK"
              size={UitkButtonSize.LARGE}
              text={<LocalizedText message="hotels.infosite.feedback.form.buttonText" />}
            />
          </div>
        </Form>
      </div>
    );
  }
}
